module.exports = __webpack_public_path__ + "static/f3647b40-78d2-424b-b54d-f5352ec2c27d 2-1e2d643880b9cfb867f60227081d75f5.jpg";